import * as React from 'react';
import { Partner } from '../../amorg-common';
import { AnonymousLayout } from './wrapperLayouts/AnonymousLayout';
import { PublicPageProvider } from '../_contexts/PublicPageContext';


export function PublicPageWrapper({
    siteId, 
    partner,
    wide,
    hideTop,
    customControls,
    children
}: React.PropsWithChildren<{
    siteId?: string, 
    partner?: Partner,
    wide?: boolean,
    hideTop?: boolean,
    customControls?: React.ReactNode
}>): JSX.Element {
    
    return (
        <PublicPageProvider siteId={siteId} partner={partner}>
            <AnonymousLayout wide={wide} hideTop={hideTop} customControls={customControls}>
                {children}
            </AnonymousLayout>
        </PublicPageProvider>
    );
}


